import http from './httpClient';

export const checkDatabaseStatus = async () => {
  try {
    const data = await http.get('/health/db-status', {
      headers: { 'Content-Type': 'application/json' }
    });
    
    if (data.success) {
      const dbType = data.isOnlineDB ? '🌐 ONLINE DATABASE' : '💻 LOCAL DATABASE';
      return data;
    }
  } catch (error) {
    // Silent failure - no error logs
    return null;
  }
};

export const logStartupInfo = () => {
  // No startup info - only database status will be shown
};

const DbStatusService = {
  checkDatabaseStatus,
  logStartupInfo
};

export default DbStatusService;